if (!customElements.get("product-macros-controller")) {
  customElements.define(
    "product-macros-controller",
    class extends HTMLElement {
      connectedCallback() {
        if (this.unsubscribe) return;
        const owner = this.closest("product-info");
        const wrapper = this.closest(".pm-nutrition-container");
        if (!owner || !wrapper) return;
        const sectionId =
          owner.dataset.originalSection || owner.dataset.section;
        if (!sectionId) return;
        const showVariant = (variantId) => {
          wrapper.querySelectorAll("[data-variant-id]").forEach((row) => {
            row.classList.toggle(
              "hidden",
              row.dataset.variantId !== String(variantId),
            );
          });
        };
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event?.data?.sectionId !== sectionId) return;
          const variantId = event.data.variant?.id;
          if (variantId == null) return;
          showVariant(variantId);
        });
        const currentId = owner.querySelector('input[name="id"]')?.value;
        if (currentId) showVariant(currentId);
      }

      disconnectedCallback() {
        this.unsubscribe?.();
        this.unsubscribe = null;
      }
    },
  );
}
